import { renderHeader } from './ui/header';
import { renderLanding } from './ui/landing';
import { renderAuth } from './ui/auth';
import { renderDashboard } from './ui/dashboard';
import { renderProject, renderSharedProject, renderPublicProject } from './ui/project';
import { renderPublicProjects } from './ui/publicProjects';
import { state } from './state';
import { setShareToken } from './api';

const app = document.getElementById('app')!;
const headerEl = document.getElementById('app-header')!;

interface Route {
  segments: string[];
}

function currentRoute(): Route {
  const hash = window.location.hash.replace(/^#/, '') || '/';
  const path = hash.split('?')[0];
  return { segments: path.split('/').filter(Boolean) };
}

async function render(): Promise<void> {
  const { segments } = currentRoute();
  // Clear any previous share-link context; only the `share` route re-enables it.
  setShareToken(null);

  renderHeader(headerEl);
  app.innerHTML = '';

  if (segments.length === 0) {
    if (state.user) {
      window.location.hash = '#/projects';
      return;
    }
    renderLanding(app);
    return;
  }

  const route = segments[0];

  if (route === 'login') {
    if (state.user) {
      window.location.hash = '#/projects';
      return;
    }
    renderAuth(app, 'login');
    return;
  }

  if (route === 'signup') {
    if (state.user) {
      window.location.hash = '#/projects';
      return;
    }
    renderAuth(app, 'signup');
    return;
  }

  if (route === 'share') {
    const token = segments[1];
    if (!token) {
      app.innerHTML = `
        <div class="container">
          <div class="error-state">
            <h3>Invalid share link</h3>
            <p class="muted">This share link is missing its token.</p>
            <a class="btn btn-primary" href="#/">Go home</a>
          </div>
        </div>
      `;
      return;
    }
    setShareToken(token);
    await renderSharedProject(app, token, segments[2] || 'overview', segments[3]);
    return;
  }

  if (route === 'public') {
    if (segments.length === 1) {
      await renderPublicProjects(app);
    } else {
      await renderPublicProject(app, segments[1], segments[2] || 'overview', segments[3]);
    }
    return;
  }

  if (route === 'projects') {
    if (!state.user) {
      window.location.hash = '#/login';
      return;
    }
    if (segments.length === 1) {
      await renderDashboard(app);
    } else {
      await renderProject(app, segments[1], segments[2] || 'overview', segments[3]);
    }
    return;
  }

  app.innerHTML = `
    <div class="container">
      <div class="error-state">
        <h3>Page not found</h3>
        <p class="muted">The page you're looking for doesn't exist.</p>
        <a class="btn btn-primary" href="#/">Go home</a>
      </div>
    </div>
  `;
}

window.addEventListener('hashchange', render);
window.addEventListener('DOMContentLoaded', render);
